import * as freespaceComponentRegistry from 'freespace-react-components';

// Optimized component mapping - cached and memoized
export const COMPONENT_MAP = (() => {
  const mapping = {};
  const componentNames = Object.keys(freespaceComponentRegistry);
  for (let i = 0; i < componentNames.length; i++) {
    const name = componentNames[i];
    mapping[name] = name;
  }
  return mapping;
})();

/**
 * Transform signage design components using model
 * @param {SignageDesign} signageDesign - The signage design model
 * @returns {Object} Object containing mainComponents, sideComponents, and allComponents
 */
export const transformSignageDesignComponents = (signageDesign) => {
  if (!signageDesign?.hasComponents()) {
    return { mainComponents: [], sideComponents: [], allComponents: [] };
  }

  const transformedComponents = signageDesign.getAllComponents().map((comp) => {
    const mappedComponent = {
      ...comp,
      componentName: COMPONENT_MAP[comp.componentId] || comp.componentId,
      Component: freespaceComponentRegistry[COMPONENT_MAP[comp.componentId] || comp.componentId]
    };
    
    // Reduced logging - only log missing components
    if (!mappedComponent.Component) {
      console.warn('🔧 Missing component:', comp.componentId, comp.displayName);
    }
    
    return mappedComponent;
  });

  return {
    mainComponents: transformedComponents.filter(comp => comp.area === "main"),
    sideComponents: transformedComponents.filter(comp => comp.area === "side"),
    allComponents: transformedComponents
  };
};
